import * as React from 'react';
import { AuthActionCreators } from '@nkr/store/index';
import { useAppHookContext } from '@nkr/utils/rest-api/useAppHookContext';
import SingleSendForm from './single-send-form';
import BulkSendPanel from './bulk-send-panel';

export interface ITemplate {
    id: number;
    name: string;
    group: string;
    liverCapable: boolean;
}

const EmailTestHarness = () => {
    const { dispatch } = useAppHookContext();
    const [templates, setTemplates] = React.useState<ITemplate[]>([]);
    const [activeTab, setActiveTab] = React.useState<'single' | 'bulk'>('single');
    const [loadError, setLoadError] = React.useState<string | null>(null);

    React.useEffect(() => {
        dispatch(AuthActionCreators.apiGet({ url: __API__ + '/admin/email-test-harness/templates' }))
            .then((res: any) => {
                if (res.data.success) setTemplates(res.data.results);
                else setLoadError('Failed to load templates.');
            })
            .catch(() => {
                setLoadError('Email test harness is not enabled or unavailable.');
            });
    }, []);

    return (
        <div className='container' style={{ paddingTop: 20 }}>
            <h2>Email Test Harness</h2>

            <div className='alert alert-info'>
                <strong>&#128231; Testing Instructions:</strong>
                <ul className='mb-0 mt-2'>
                    <li>All test emails are prefixed with <code>[EmailTestHarness]</code> in the subject line</li>
                    <li>Check <strong>SMTP4Dev</strong> at{' '}
                        <a href='http://69.74.66.18:5000/' target='_blank' rel='noreferrer'>
                            http://69.74.66.18:5000/
                        </a>
                    </li>
                    <li>Emails are sent to the test email address you specify below</li>
                </ul>
            </div>

            {loadError && (
                <div className='alert alert-danger'>{loadError}</div>
            )}

            {!loadError && (
                <>
                    <ul className='nav nav-tabs' style={{ marginBottom: 20 }}>
                        <li className={activeTab === 'single' ? 'active' : ''}>
                            <a href='#' onClick={e => { e.preventDefault(); setActiveTab('single'); }}>
                                Send Single Email
                            </a>
                        </li>
                        <li className={activeTab === 'bulk' ? 'active' : ''}>
                            <a href='#' onClick={e => { e.preventDefault(); setActiveTab('bulk'); }}>
                                Bulk Send
                            </a>
                        </li>
                    </ul>

                    {activeTab === 'single' && <SingleSendForm templates={templates} />}
                    {activeTab === 'bulk' && <BulkSendPanel templates={templates} />}

                    <hr style={{ marginTop: 30 }} />

                    <div className='panel panel-default' style={{ marginTop: 20 }}>
                        <div className='panel-heading'><h5 style={{ margin: 0 }}>Usage Instructions</h5></div>
                        <div className='panel-body'>
                            <ol>
                                <li>Select an email template from the dropdown</li>
                                <li>Enter your test email address (or use the default)</li>
                                <li>Optionally override the first name, last name, or center name</li>
                                <li>Select Kidney or Liver to test organ-specific templates</li>
                                <li>Click <strong>"Send Test Email"</strong></li>
                                <li>Check <a href='http://69.74.66.18:5000/' target='_blank' rel='noreferrer'>SMTP4Dev</a> for the email with <code>[EmailTestHarness]</code> prefix</li>
                            </ol>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default EmailTestHarness;
